import { useState } from "react";
import format from "date-fns/format";
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from "react-redux";
import axios from 'axios';
import { Grid, Typography } from "@mui/material";
import SearchFormHourly from "./SearchFormHourly";
import HourlyCDRChart from "./HourlyCDRChart";
import constants from "../../../../constants";
import Loader from "../../../loader";
import Frame from "../../../frame";
import customToolbar from "../../../customToolbar";
import useFormData from "../../../../useFormData";

function HourlyCDR() {

    let [data, setData] = useState(null);
    let [err, setError] = useState(null);
    let [form, setForm] = useState(null);
    let [nodata, setNodata] = useState(false);

    let [showLoader, setShowLoader] = useState(false);

    let config = useSelector(state => state.session.config);

    let getFormData = useFormData();

    async function handleSubmit(form) {
        setShowLoader(true);
        setNodata(false);

        let s = format(form.startDate, 'dd-MM-yyyy');
        s += 'T00:00:00';
        let e = format(form.endDate, 'dd-MM-yyyy');
        e += 'T23:59:59';
        let a = 'HourlyMissCalls';


        try {
            let formData = getFormData();
            formData.append("action", a);
            formData.append("startDate", s);
            formData.append("endDate", e);

            const response = await axios.post(`${config.reportsURL}`, formData, {
                timeout: config.apiTimeOut,
                headers: {
                    apiKey: constants.k
                }
            });
            if (response.status === 200 && response.data) {
                if (response.data.status === "SUCCESS") {
                    if (response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
                        setData(response.data.data);
                        setForm(form);
                    } else {
                        setNodata(true);
                    }
                }
            }
            setShowLoader(false);
        } catch (err) {
            setShowLoader(false);
            setNodata(true);
        }
    }

    return (<>
        <Typography variant="body1">Hourly CDR</Typography>
        <SearchFormHourly submitCallback={handleSubmit} />
        <div style={{ marginTop: '5px' }}>
            <ShowTable data={data} form={form} />
        </div>
        <Loader showLoader={showLoader} />
        {
            nodata ?
                <div style={{ textAlign: 'center' }}>No Data Found!</div> : null
        }
    </>)
}

export default HourlyCDR;

function ShowTable({ data, form }) {
    if (!form || !data) {
        return <></>;
    }

    // console.log("data >>>", data, form);

    // return null;
    return <Table1 data={data} form={form} />
}

function processData(data) {
    let rows = data ?? [];
    rows = rows.map(r => {
        try {
            let h = parseInt(r.CallTime);
            r.CallTime = h;
        } catch (e) {
            r.CallTime = 0;
        }

        try {
            let t = parseInt(r.TotalMissCalls);
            r.TotalMissCalls = t;
        } catch (e) {
            r.TotalMissCalls = 0;
        }
        return r;
    });

    return rows;
}

function Table1({ data, form }) {

    let rows = processData(data);
    rows = rows.map(r => ({ id: (`${r.CallDate}_${r.CallTime}`), ...r }));

    let columns = [
        { field: 'CallDate', headerName: 'Call Date', width: 250, sortable: true },
        { field: 'CallTime', headerName: 'Hour', width: 150, sortable: true },
        { field: 'TotalMissCalls', headerName: 'No.of Missed Calls', width: 150, sortable: true }
    ]

    let CustomToolbar = customToolbar("HourlyCDR");

    let [sortModel, setSortModel] = useState([{
        field: 'CallDate',
        sort: 'asc'
    }])

    return (<>
        <Grid container spacing={1}>
            <Grid item lg={6}>
                <DataGrid
                    rows={rows} columns={columns}
                    slots={{
                        toolbar: CustomToolbar,
                    }}
                    pageSizeOptions={[25, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 25 }
                        }
                    }}
                    sortModel={sortModel}
                    onSortModelChange={(s) => setSortModel(s)}
                />
            </Grid>
            <Grid item lg={6}>
                {/* <HourlyCDRChart data={rows} /> */}
            </Grid>
        </Grid>
    </>)
}